import { TvlGraph, type ApySeries, } from "../TvlGraph";
import { Typography, } from "@bracket/ui/components";
import styled from "styled-components";

export declare type VaultCarProps = {
	vault: VaultShortDetail;
}

export const VaultCard = ({
	vault,
}: VaultCarProps) => {
	const { tvl, apy_series, manager, } = vault;
	const currentApy = apy_series[apy_series.length - 1].apy;
	return (
		<Card>
			<Typography variant="h3">{vault.symbol}</Typography>
			<Typography variant="p">Target Est. APY Net of Fees</Typography>
			<Typography variant="p">{currentApy.toFixed(2)}%</Typography>
			<TvlGraph apy_series={vault.apy_series} />
			<VaultCardMetric label="TVL" value={tvl.usd} />
			<VaultCardMetric label="Manager" value={manager} />
		</Card>
	);
};

const VaultCardMetric = ({
	label,
	value,
}) => {
	return (
		<MetricContainer>
			<Typography variant="p">{label}</Typography>
			<Typography variant="p">{value}</Typography>
		</MetricContainer>
	)
}



export declare type VaultShortDetail = {
	symbol: string;
	name: string;
	apy_series: ApySeries;
	manager: string;
	tvl: { asset: string, usd: number, };
};

export declare type VaultsShortDetail = VaultShortDetail[];


const Card = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	min-width: 600px;
	background-color: #111;
	border-radius: 10px;
	padding: 10px;
	> p {
	 color: white;
	}
`;


const MetricContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 10px;
`;
